import { Box, Container, Stack, StackDivider, Text } from '@chakra-ui/react'
import ChangePasswordFormHandle from '@Modules/home/containers/forms/ChangePasswordHandle/ChangePasswordFormHandle';
import ProfileFormHandler from '@Modules/home/containers/forms/ProfileFormHandler/ProfileFormHandler';

const Profile = () => (
  <Container maxW={'full'} py={{ base: '4', md: '8' }}>
    <Stack direction={{ base: 'column', lg: 'row' }} spacing="5" divider={<StackDivider />}>
      <Stack
        direction={{ base: 'column' }}
        spacing={{ base: '5', lg: '8' }}
        justify="start"
        width={"full"}
      >
        <Box flexShrink={0}>
          <Text fontSize="lg" fontWeight="medium">
            Your Profile
          </Text>
          <Text color="muted" fontSize="sm">
            Update your profile
          </Text>
        </Box>
        <ProfileFormHandler />
      </Stack>

      <Stack
        direction={{ base: 'column' }}
        spacing={{ base: '5', lg: '8' }}
        justify="start"
        width={"full"}
      >
        <Box flexShrink={0}>
          <Text fontSize="lg" fontWeight="medium">
            Your Password
          </Text>
          <Text color="muted" fontSize="sm">
            Update your password
          </Text>
        </Box>
        <ChangePasswordFormHandle />
      </Stack>
    </Stack>
  </Container>
)

export default Profile;